import React from "react";

const Ucb = () => {
  return (
    <div className="w-full">
      {/* Header */}
      <h1 className="text-4xl font-bold text-center mt-10 mb-6 text-gray-900">
        Urban Cooperative Banks (UCBs)
      </h1>

      {/* Overview Section */}
      <div className="bg-blue-50 rounded-xl p-10 mb-14">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
          Overview
        </h2>
        <div className="border-l-4 border-blue-600 pl-6">
          <p className="text-lg text-gray-700 leading-relaxed">
            Urban Cooperative Banks (UCBs) provide banking and credit services to urban and semi-urban
            communities, including salaried individuals, small traders, self-employed professionals,
            and micro and small enterprises (MSMEs). They operate on cooperative principles while
            offering modern financial services.
          </p>
        </div>
      </div>
{/* Core Services Section */}
<div className="mb-16">
  <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
    Core Services
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-6 lg:px-20">
    {[
      { title: "Savings and Current Accounts", bg: "bg-red-100" },
      { title: "Fixed and Recurring Deposits", bg: "bg-red-200" },
      { title: "Personal, Housing & Vehicle Loans", bg: "bg-blue-100" },
      { title: "MSME Loans & Working Capital", bg: "bg-blue-200" },
      { title: "Digital Payment Services", bg: "bg-amber-100" },
      { title: "Safe & Transparent Banking", bg: "bg-amber-200" },
    ].map((service, index) => (
      <div
        key={index}
        className={`${service.bg} h-28 rounded-xl flex items-center justify-center text-center shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300`}
      >
        <p className="text-gray-800 text-base font-semibold px-4 leading-snug">
          {service.title}
        </p>
      </div>
    ))}
  </div>
</div>



{/* Why UCBs Matter - Circular Cards */}
<div className="mb-14">
  <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
    Why UCBs Matter
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 px-6 lg:px-20 place-items-center">
    {[
      "Enhance financial inclusion in urban neighbourhoods",
      "Offer customer-friendly and community-centric services",
      "Support small businesses and self-employed individuals",
      "Provide accessible credit at reasonable interest rates"
    ].map((text, index) => (
      <div
        key={index}
        className="bg-blue-100 w-56 h-56 rounded-full flex items-center justify-center text-center shadow-md hover:shadow-xl hover:-translate-y-1 transition-all"
      >
        <p className="font-medium text-gray-800 px-6 leading-relaxed">
          {text}
        </p>
      </div>
    ))}
  </div>
</div>

{/* Operational Strength */}
<div className="mb-16">
  <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
    Operational Strength
  </h2>

  <div className="bg-sky-400 py-8">
    <div className="flex gap-6 overflow-x-auto px-6 lg:px-20 scrollbar-hide">
      
      <div className="min-w-[320px] bg-white rounded-2xl p-6 flex items-center gap-5 shadow-md ml-10">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 text-xl font-bold">
          01
        </div>
        <p className="text-gray-800 font-semibold leading-snug">
          Democratically managed institutions
        </p>
      </div>

      <div className="min-w-[320px] bg-white rounded-2xl p-6 flex items-center gap-5 shadow-md">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 text-xl font-bold">
          02
        </div>
        <p className="text-gray-800 font-semibold leading-snug">
          Direct service to urban customers
        </p>
      </div>

      <div className="min-w-[320px] bg-white rounded-2xl p-6 flex items-center gap-5 shadow-md">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 text-xl font-bold">
          03
        </div>
        <p className="text-gray-800 font-semibold leading-snug">
          Strong regulatory compliance and governance
        </p>
      </div>

    </div>
  </div>
</div>
  </div>
  );
};

export default Ucb;
